import { ChevronRight } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'

import { Header } from '@/components'
import { Card } from '@/components/ui'
import Loader from '@/common/components/Loader'
import { IFestivalMenuItem, getFestivalsMenu } from '@/core/services/menu'
import { EditModulesModal } from './EditModulesModal'
import { MessageBox } from '../messages/MessageBox'

export const WLSettingsPage: React.FC = (): JSX.Element => {
  const [festivals, setFestivals] = useState<IFestivalMenuItem[]>([])
  const [selectedFestival, setSelectedFestival] = useState<IFestivalMenuItem>()
  const [showModulesModal, setShowModulesModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [errorStatus, setErrorStatus] = useState<number | undefined>(undefined)
  const [showMessageBox, setShowMessageBox] = useState(false)
  const [message, setMessage] = useState('')

  const getData = useCallback(async () => {
    try {
      setLoading(true)
      const response = await getFestivalsMenu()
      setFestivals(response.data)
    } catch (e) {
      if (e instanceof Error) {
        setIsError(true)
        setShowMessageBox(true)
        setMessage(e.message)
        setErrorStatus(
          (e as { response?: { status?: number } })?.response?.status,
        )
      } else {
        console.error(e)
      }
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  const openModules = (festival: IFestivalMenuItem) => {
    setSelectedFestival(festival)
    setShowModulesModal(true)
  }

  return (
    <>
      <Header pageTitle="WL Settings" breadcrumbs={['WL Settings']} />
      {loading && <Loader />}
      <Card className="p-2 !bg-monochrome-4-60 px-[32px] py-[30px]">
        {festivals.map((festival) => (
          <button
            key={festival.id}
            onClick={() => openModules(festival)}
            className="flex w-full items-center justify-between border-b border-monochrome-120 px-4 py-6 text-left last:border-b-0 transition-colors hover:bg-monochrome-3-60"
          >
            <span className="text-title-xs font-bold text-monochrome-1">
              {festival.name}
            </span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full border border-monochrome-120 text-monochrome-1">
              <ChevronRight className="h-4 w-4" />
            </span>
          </button>
        ))}
      </Card>

      <EditModulesModal
        open={showModulesModal}
        onOpenChange={setShowModulesModal}
        festival={selectedFestival}
      />
      <MessageBox
        message={message}
        setShowMessageBox={setShowMessageBox}
        showMessageBox={showMessageBox}
        isError={isError}
        errorStatus={errorStatus}
      />
    </>
  )
}
